import { Badge, Group, Paper, SimpleGrid, Stack, Text, UnstyledButton } from '@mantine/core';

export default function LauncherScreen({ flows, onSelect, fetchError }) {
  if (fetchError) {
    return (
      <Stack gap="md" align="center" py="xl">
        <Text fw={700} size="xl" style={{ color: 'var(--aviary-ink)' }}>
          What are you here to find?
        </Text>
        <Text c="red" size="sm" ta="center">
          Couldn&apos;t load flows: {fetchError}
        </Text>
      </Stack>
    );
  }

  if (!flows || flows.length === 0) {
    return (
      <Stack gap="md" align="center" py="xl">
        <Text fw={700} size="xl" style={{ color: 'var(--aviary-ink)' }}>
          What are you here to find?
        </Text>
        <Text size="sm" style={{ color: 'var(--aviary-muted)' }}>
          No flows available yet.
        </Text>
      </Stack>
    );
  }

  return (
    <Stack gap="xl">
      <Text fw={700} size="xl" style={{ color: 'var(--aviary-ink)', fontSize: 28, lineHeight: 1.25 }}>
        What are you here to find?
      </Text>

      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
        {flows.map((flow) => (
          <UnstyledButton
            key={flow.id}
            onClick={() => onSelect(flow)}
            style={{ display: 'block', height: '100%' }}
          >
            <Paper
              p="lg"
              radius="md"
              withBorder
              style={{
                background: 'var(--aviary-surface)',
                height: '100%',
                transition: 'border-color 120ms ease, box-shadow 120ms ease',
              }}
              styles={{
                root: {
                  '&:hover': {
                    borderColor: 'var(--mantine-color-sage-5)',
                    boxShadow: '0 4px 16px rgba(60, 140, 124, 0.12)',
                  },
                },
              }}
            >
              <Stack gap="sm">
                <Text size="2rem" lh={1}>{flow.icon}</Text>
                <div>
                  <Text fw={600} size="lg" style={{ color: 'var(--aviary-ink)' }}>
                    {flow.label}
                  </Text>
                  <Text size="sm" style={{ color: 'var(--aviary-muted)' }}>
                    {flow.tagline}
                  </Text>
                </div>
                <Group>
                  <Badge color="sage" variant="light" radius="xl" size="sm" style={{ opacity: 0.75 }}>
                    {flow.search_source}
                  </Badge>
                </Group>
              </Stack>
            </Paper>
          </UnstyledButton>
        ))}
      </SimpleGrid>
    </Stack>
  );
}
